/**
 * For general chart CRUD actions
 */

export enum ChartModelActionType {
  LoadEmbeddedTables = 'LoadEmbeddedTables',
  LoadEmbeddedTablesSuccess = 'LoadEmbeddedTablesSuccess',
  LoadEmbeddedTablesFailure = 'LoadEmbeddedTablesFailure',

  LoadEmbeddedChartColorPaletteSuccess = 'LoadEmbeddedChartColorPaletteSuccess',
  LoadEmbeddedChartColorPaletteFailure = 'LoadEmbeddedChartColorPaletteFailure',

  UpdateTableExcludedColumns = 'UpdateTableExcludedColumns',
  UpdateTableExcludedColumnsFailure = 'UpdateTableExcludedColumnsFailure',
  UpdateTableColumnSettings = 'UpdateTableColumnSettings',
  UpdateTableColumnSettingsFailure = 'UpdateTableColumnSettingsFailure',
  UpdateTableSuccess = 'UpdateTableSuccess',

  AddUndoEntry = 'PushChange',

  DestroyTable = 'DestroyTable',
  DestroyTableSuccess = 'DestroyTableSuccess',

  AddTableSuccess = 'AddTableSuccess',
}
